import { defaultCss as bootstrapCss } from "../plugins/themes/bootstrap/cssbootstrap";
import { defaultCss as bootstrapMaterialCss } from "../plugins/themes/bootstrapmaterial/cssbootstrapmaterial";
export * from "../plugins/themes/bootstrap/theme-settings";
export * from "../plugins/themes/bootstrapmaterial/theme-settings";

export var defaultBootstrapCss = bootstrapCss;
export var defaultBootstrapMaterialCss = bootstrapMaterialCss;